import client from './client'

export class Request {
  private controller: AbortController

  signal: AbortSignal
  client: typeof client

  constructor() {
    this.controller = new AbortController()

    this.signal = this.controller.signal
    this.client = client
  }

  abort() {
    this.controller.abort()
  }
}
